import React from 'react';

const IconTimsBag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="121"
    height="120"
    viewBox="0 0 121 120"
    fill="none"
  >
    <path
      d="M104.313 22.6689H88.7822V11.7686L82.4156 5.40202H46.7243L40.3577 11.7686V22.6689H24.8272L20.2935 120H108.846L104.313 22.6689ZM46.7243 11.9615H82.4156V22.6689H46.7243V11.9615Z"
      fill="#C8102E"
    />
    <path
      d="M106.532 117.492H14.8918L19.5221 17.2669H35.0526V7.23472L42.2873 0H79.1362L86.3709 7.23472V17.3633H101.901L106.532 117.492ZM17.9787 114.598H103.541L99.104 20.1608H83.477V8.48874L77.9786 2.99036H43.5413L38.043 8.48874V20.2572H22.416L17.9787 114.598ZM80.0043 20.2572H41.4192V6.65594H80.0043V20.2572ZM44.313 17.3633H77.1105V9.54983H44.313V17.3633Z"
      fill="#3F2021"
    />
  </svg>
);

export default IconTimsBag;
